import NewsFilter from "@/filters/NewsFilter";
import AnnouncementsFilter from "@/filters/AnnouncementsFilter";
import StatementsFilter from "@/filters/StatementsFilter";

export default class Filter {
    init(postType, page) {
        switch (postType) {
            case "news":
                let newsFilter = new NewsFilter();
                newsFilter.ajaxCall(page);
                break;
            case "announcements":
                let announcementsFilter = new AnnouncementsFilter();
                announcementsFilter.ajaxCall(page);
                break;
            case "statements":
                let statementsFilter = new StatementsFilter();
                statementsFilter.ajaxCall(page);
                break;
        }
    }
}
